// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableComplaintList_Component__36MAK"};